/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UseCaseName } from './UseCaseName';
import { UseCaseNameFromJSON, UseCaseNameFromJSONTyped, UseCaseNameToJSON } from './UseCaseName';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface PoorAiModel
 */
export interface PoorAiModel {
  /**
   *
   * @type {number}
   * @memberof PoorAiModel
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof PoorAiModel
   */
  name: string;
  /**
   *
   * @type {UseCaseName}
   * @memberof PoorAiModel
   */
  readonly useCase: UseCaseName;
  /**
   *
   * @type {number}
   * @memberof PoorAiModel
   */
  useCaseId: number;
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof PoorAiModel
   */
  taskType?: TaskTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PoorAiModel
   */
  technicalOwner: string;
  /**
   *
   * @type {string}
   * @memberof PoorAiModel
   */
  technicalInfo: string;
  /**
   *
   * @type {string}
   * @memberof PoorAiModel
   */
  datasetInfo: string;
  /**
   *
   * @type {Date}
   * @memberof PoorAiModel
   */
  liveFrom?: Date | null;
  /**
   *
   * @type {Date}
   * @memberof PoorAiModel
   */
  decomissionedOn?: Date | null;
}

/**
 * Check if a given object implements the PoorAiModel interface.
 */
export function instanceOfPoorAiModel(value: object): value is PoorAiModel {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('useCase' in value) || value['useCase'] === undefined) return false;
  if (!('useCaseId' in value) || value['useCaseId'] === undefined) return false;
  if (!('technicalOwner' in value) || value['technicalOwner'] === undefined) return false;
  if (!('technicalInfo' in value) || value['technicalInfo'] === undefined) return false;
  if (!('datasetInfo' in value) || value['datasetInfo'] === undefined) return false;
  return true;
}

export function PoorAiModelFromJSON(json: any): PoorAiModel {
  return PoorAiModelFromJSONTyped(json, false);
}

export function PoorAiModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PoorAiModel {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    useCase: UseCaseNameFromJSON(json['use_case']),
    useCaseId: json['use_case_id'],
    taskType: json['task_type'] == null ? undefined : TaskTypeEnumFromJSON(json['task_type']),
    technicalOwner: json['technical_owner'],
    technicalInfo: json['technical_info'],
    datasetInfo: json['dataset_info'],
    liveFrom: json['live_from'] == null ? undefined : new Date(json['live_from']),
    decomissionedOn: json['decomissioned_on'] == null ? undefined : new Date(json['decomissioned_on']),
  };
}

export function PoorAiModelToJSON(value?: Omit<PoorAiModel, 'id' | 'useCase'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    use_case_id: value['useCaseId'],
    task_type: TaskTypeEnumToJSON(value['taskType']),
    technical_owner: value['technicalOwner'],
    technical_info: value['technicalInfo'],
    dataset_info: value['datasetInfo'],
    live_from: value['liveFrom'] == null ? undefined : (value['liveFrom'] as any).toISOString().substring(0, 10),
    decomissioned_on:
      value['decomissionedOn'] == null ? undefined : (value['decomissionedOn'] as any).toISOString().substring(0, 10),
  };
}
